import type {
    DashboardProfile,
    DashboardProfileConfig,
    DashboardProfileMetadata,
} from "@dashboard/utils/dashboard.types";
import { hseAxiosInstance } from "./axiosInstance";

const profilePath = (productInstanceId: number) =>
    `/dashboard-instances/${productInstanceId}/profiles`;

export async function getDashboardProfiles(
    productInstanceId: number,
): Promise<DashboardProfileMetadata[]> {
    const response = await hseAxiosInstance.get<DashboardProfileMetadata[]>(
        profilePath(productInstanceId),
    );
    return response.data;
}

export async function createDashboardProfile(
    productInstanceId: number,
    data: { name: string; config: DashboardProfileConfig },
): Promise<DashboardProfile> {
    const response = await hseAxiosInstance.post<DashboardProfile>(
        profilePath(productInstanceId),
        data,
    );
    return response.data;
}

export async function getDashboardProfile(
    productInstanceId: number,
    profileId: number,
): Promise<DashboardProfile> {
    const response = await hseAxiosInstance.get<DashboardProfile>(
        `${profilePath(productInstanceId)}/${profileId}`,
    );
    return response.data;
}

export async function updateDashboardProfile(
    productInstanceId: number,
    profileId: number,
    data: { name?: string; config?: DashboardProfileConfig },
): Promise<DashboardProfile> {
    const response = await hseAxiosInstance.patch<DashboardProfile>(
        `${profilePath(productInstanceId)}/${profileId}`,
        data,
    );
    return response.data;
}

export async function deleteDashboardProfile(
    productInstanceId: number,
    profileId: number,
): Promise<DashboardProfile> {
    const response = await hseAxiosInstance.delete<DashboardProfile>(
        `${profilePath(productInstanceId)}/${profileId}`,
    );
    return response.data;
}
